<template>
  <div>
    <div class="row justify-center">
      <Container
        orientation="horizontal"
        @drop="onDrop"
      >
        <Draggable
          v-for="planElement in bookingWeek.planElements.data"
          :key="planElement.id"
        >
          <div
            class="col-auto column justify-center items-center cursor-pointer plan-element"
            @click="showForm(planElement)"
          >
            <div class="col-auto q-pl-md items-center">
              <div class="row justify-center items-center">
                <q-icon
                  class="controls"
                  name="drag_indicator"
                  size="sm"
                />
                <div
                  :style="'color: ' + planElement.color + '; border-color: ' + planElement.color + '; background-color: ' + planElement.color + '33;'"
                  class="title-count"
                >
                  {{ planElement.titleCount }}
                </div>
                <div class="column q-ml-xs controls">
                  <q-btn
                    size="sm"
                    icon="add"
                    dense
                    @click.stop="planElement.titleCount += 1; planElement.validateBookingWeekMovies()"
                  />
                  <q-btn
                    size="sm"
                    icon="remove"
                    dense
                    :disable="planElement.titleCount <= 1"
                    @click.stop="planElement.titleCount -= 1; planElement.validateBookingWeekMovies()"
                  />
                </div>
              </div>
              <div class="col-auto text-center">
                {{ planElement.name }}
              </div>
            </div>
            <q-menu
              touch-position
              context-menu
            >
              <q-list
                style="width: 200px;"
              >
                <q-item
                  v-close-popup
                  clickable
                  :disable="!bookingWeek.canRemovePlanElement(planElement)"
                  @click="remove(planElement)"
                >
                  <q-item-section>
                    {{ $t('actions.remove') }}
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </div>
        </Draggable>
      </Container>
      <div
        class="col-auto column justify-center items-center cursor-pointer q-mx-md"
        @click="add"
      >
        <div
          class="title-count col-auto"
          :style="'color: #888;'"
        >
          +
        </div>
        <div class="col-auto text-center">
          &nbsp;
        </div>
      </div>
    </div>
    <plan-element-form
      ref="form"
      :submodel="true"
    />
    <select-plan-elements-dialog
      ref="dialog"
      :booking-week="bookingWeek"
    />
  </div>
</template>

<script>

import SelectPlanElementsDialog from 'src/modules/admin/plan-element/components/SelectPlanElementsDialog'
import PlanElementForm from 'src/modules/admin/plan-element/PlanElementForm'
import { Container, Draggable } from 'vue3-smooth-dnd'

export default {
  name: 'BookingWeekDetail',
  components: {
    Container,
    Draggable,
    PlanElementForm,
    SelectPlanElementsDialog
  },
  props: {
    bookingWeek: {
      type: Object,
      required: true
    }
  },
  methods: {
    add () {
      this.$refs.dialog.show()
    },
    showForm (planElement) {
      this.$refs.form.show(planElement)
    },
    onDrop (dropResult) {
      const newList = this.$mh.applyDrag(this.bookingWeek.planElements.data, dropResult)
      _.each(newList, (planElement, index) => { planElement.displayOrder = index })
      this.bookingWeek.planElements.setData(newList)
    },
    remove (planElement) {
      if (this.bookingWeek.canRemovePlanElement(planElement)) {
        planElement.remove()
      }
    }
  }
}

</script>

<style scoped>
  .title-count {
    text-align: center;
    width: 40px;
    height: 40px;
    font-size: 18px;
    line-height: 37px;
    border-radius: 100px;
    border: solid 1px;
  }
  .title-count.add {
    border: none;
  }
  .controls {
    width: 0;
    overflow: hidden;
    transition: width 0.1s;
  }
  .plan-element {
    width: 110px;
  }
  .plan-element:hover .controls {
    width: 25px;
  }

  /* Prevent controls from being drawn while dragging over */
  .animated .plan-element .controls {
    width: 0;
  }
</style>
